import styled, { css } from 'styled-components';

type WrapperProps = {
    background: 'light' | 'dark';
    color: 'primary' | 'secondary' | 'tertiary';
    fluid: boolean;
    disabled: boolean;
    size: 'hero' | 'large' | 'small';
};

const heroButtonCommon = css`
    border-radius: 40px;
    height: 80px;
    padding: 0 80px;
`;

const largeButtonCommon = css`
    border-radius: 30px;
    height: 60px;
    padding: 0 60px;
`;

const smallButtonCommon = css`
    border-radius: 20px;
    height: 40px;
    padding: 0 40px;
`;

const buttonBase = styled.button<WrapperProps>`
    cursor: pointer;
    outline: none;
    width: ${(props) => (props.fluid ? '100%' : 'auto')};

    div {
        display: inline-block;
        vertical-align: middle;
    }
`;

const primaryButtonCommon = styled(buttonBase)<WrapperProps>`
    background-color: ${(props) => props.theme?.colors.purple};
    border: 0;
    color: ${(props) => props.theme?.colors.white};

    :hover {
        background-color: ${(props) =>
            props.background === 'light' ? props.theme?.colors.black : props.theme?.colors.white};
        color: ${(props) => (props.background === 'light' ? props.theme?.colors.white : props.theme?.colors.black)};
    }
`;

const secondaryButtonCommon = styled(buttonBase)<WrapperProps>`
    background: none;
    border: 1px solid
        ${(props) => (props.background === 'light' ? props.theme?.shades.black[10] : props.theme?.shades.white[10])};
    color: ${(props) => (props.background === 'light' ? props.theme?.colors.black : props.theme?.colors.white)};

    :hover {
        background-color: ${(props) =>
            props.background === 'light' ? props.theme?.colors.black : props.theme?.colors.white};
        color: ${(props) => (props.background === 'light' ? props.theme?.colors.white : props.theme?.colors.black)};
    }
`;

const tertiaryButtonCommon = styled(buttonBase)<WrapperProps>`
    background-color: ${(props) =>
        props.background === 'light' ? props.theme?.shades.black[5] : props.theme?.shades.white[10]};
    border: 0;
    color: ${(props) => (props.background === 'light' ? props.theme?.colors.black : props.theme?.colors.white)};

    :hover {
        background-color: ${(props) =>
            props.background === 'light' ? props.theme?.shades.black[30] : props.theme?.shades.white[30]};
        color: ${(props) => (props.background === 'light' ? props.theme?.colors.black : props.theme?.colors.white)};
    }
`;

const disabledButtonCommon = styled(buttonBase)<WrapperProps>`
    background-color: ${(props) =>
        props.background === 'light' ? props.theme?.shades.black[10] : props.theme?.shades.white[10]};
    border: 0;
    color: ${(props) => (props.background === 'light' ? props.theme?.shades.black[10] : props.theme?.shades.white[30])};
    cursor: auto;
`;

// PRIMARY
export const ButtonPrimaryHero = styled(primaryButtonCommon)`
    ${heroButtonCommon}
`;
export const ButtonPrimaryLarge = styled(primaryButtonCommon)`
    ${largeButtonCommon}
`;
export const ButtonPrimarySmall = styled(primaryButtonCommon)`
    ${smallButtonCommon}
`;

// SECONDARY
export const ButtonSecondaryHero = styled(secondaryButtonCommon)`
    ${heroButtonCommon}
`;
export const ButtonSecondaryLarge = styled(secondaryButtonCommon)`
    ${largeButtonCommon}
`;
export const ButtonSecondarySmall = styled(secondaryButtonCommon)`
    ${smallButtonCommon}
`;

// TERTIARY
export const ButtonTertiaryHero = styled(tertiaryButtonCommon)`
    ${heroButtonCommon}
`;
export const ButtonTertiaryLarge = styled(tertiaryButtonCommon)`
    ${largeButtonCommon}
`;
export const ButtonTertiarySmall = styled(tertiaryButtonCommon)`
    ${smallButtonCommon}
`;

// DISABLED
export const ButtonDisabledHero = styled(disabledButtonCommon)`
    ${heroButtonCommon}
`;
export const ButtonDisabledLarge = styled(disabledButtonCommon)`
    ${largeButtonCommon}
`;
export const ButtonDisabledSmall = styled(disabledButtonCommon)`
    ${smallButtonCommon}
`;

export const IconContainer = styled.div`
    height: 25px;
    width: 25px;
    margin-right: 12px;
`;
